Vendd.Scripts.load(function () {

    if (isTouch()) {
        initMobileMenus();
    } else {
        initMainMenu();
    }

    var $testDriveForm = $('.x-test-drive-form');
    var testDriveForm = $testDriveForm.get(0);
    var $serviceForm = $('.x-service-form');
    var serviceForm = $serviceForm.get(0);
    var $interestForm = $('.x-interest-form');
    var interestForm = $interestForm.get(0);


    function openCustomForm() {
        if (window.location.href.indexOf('#') > 0) {
            var query,form,brand,model;
            query = window.location.href
                    .slice(window.location.href.indexOf('#') + 1);
            form = query.slice(0, query.indexOf('?'));
            brand = query.slice(query.indexOf('brand=') + 6,query.indexOf('&'));
            model = query.slice(query.indexOf('model=') + 6);
            if (form) {
                brandVal = brand;
                brandText = brand;
                modelText = model;
                modelVal = model;
                formType = form;

                if (formType == 'testDrive') {
                    testDriveForm.reset();
                    testDriveForm.handleErrors();
                    testDriveForm.updateBrand(brandVal, brandText);
                    testDriveForm.updateModel(modelVal,modelText);
                    testDriveForm.updateType(formType,0);
                    testDriveForm.show(true);
                }else if (formType == 'bookService') {
                    serviceForm.reset();
                    serviceForm.handleErrors();
                    serviceForm.updateBrand(brandVal, brandText);
                    serviceForm.updateModel(modelVal,modelText);
                    serviceForm.updateType(formType,0);
                    serviceForm.show(true);
                }
            }
        }
    }

    $('.secondary-menu a').on('click', function (e) {            
            var element = $(this);//, brandVal, brandText, formType, formExternalService;
            if (element.hasClass("only-link"))
                return;
            if (element.hasClass("js-brand"))
                element = $(this).closest(".hasChildren");
            else
                element = $(this).parent();

            var formType = element.attr('data-type');

            var formExternalService = element.attr('data-extservice');
            var externlLink = $(this).attr('data-external-link');

            $("#preSelectedMakeModel").val("false");
            $("#preSelectedMakeModel").change();

            if (formType !== 'requestQuote') {
                e.preventDefault();
                if (formType === 'testDrive') {
                    testDriveForm.reset();
                    testDriveForm.handleErrors();
                    //testDriveForm.updateBrand(brandVal, brandText);
                    testDriveForm.updateType(formType, formExternalService);
                    testDriveForm.updateExternalLink(externlLink);
                    $.fancybox.open({
                        src  : '#testDrive',
                        type : 'inline',
                        touch: false
                    });
                } else if (formType === 'bookService') {
                    serviceForm.reset();
                    serviceForm.handleErrors();
                    //serviceForm.updateBrand(brandVal, brandText);
                    serviceForm.updateType(formType, formExternalService);
                    serviceForm.updateExternalLink(externlLink);
                    $.fancybox.open({
                        src  : '#bookService',
                        type : 'inline',
                        touch: false
                    });
                }
            }
            else {
                var $interestFormConfigurator = $('.x-interest-form-configurator');
                var interestFormConfigurator = $('.x-interest-form-configurator').get(0);

                if ($interestFormConfigurator.length > 0) {
                    interestFormConfigurator.reset();
                }

                if ($interestForm.length > 0) {
                    interestForm.reset();
                }
                
                interestForm.updateType(formType, formExternalService);

                interestForm.updateExternalLink(externlLink);
            }
    });

    $('.js-brand', '.secondary-menu').on('click', function () {
        
        var $this = $(this), brandVal, brandText, formType, formExternalService;
        if (!$this.hasClass("custom-menu")) {
            //alert("js-brand");

            brandVal = $this.attr('data-brand');
            brandText = $.trim($this.text());
            formType = $this.closest('li[data-type]').addClass('hidden').attr('data-type');
            formExternalService = $this.closest('li[data-type]').addClass('hidden').attr('data-extservice')
            externlLink = $this.attr('data-external-link');

            if (formType != 'requestQuote') {
                if (formType == 'testDrive') {
                    testDriveForm.reset();
                    testDriveForm.handleErrors();
                    testDriveForm.updateBrand(brandVal, brandText);
                    testDriveForm.updateType(formType, 0);
                    testDriveForm.updateExternalLink(externlLink);
                    testDriveForm.show(true);
                } else if (formType == 'bookService') {
                    serviceForm.reset();
                    serviceForm.handleErrors();
                    serviceForm.updateBrand(brandVal, brandText);
                    serviceForm.updateType(formType, 0);
                    serviceForm.updateExternalLink(externlLink);
                    serviceForm.show(true);
                }
            }
        }
    });

    $('.secondary-menu .request-a-quote').on('click', function (e) {
       
        var $this = $(this), formExternalService, brandVal, brandText;

        if (!$this.hasClass("custom-menu")) {
            //alert("request-a-quote");

            brandVal = $this.attr('data-brand');
            brandText = $.trim($this.text());
            externlLink = $this.attr('data-external-link');
            var $interestFormConfigurator = $('.x-interest-form-configurator');
            var interestFormConfigurator = $('.x-interest-form-configurator').get(0);

            formExternalService = $this.parent().attr('data-extservice');

            if ($interestFormConfigurator.length > 0) {
                interestFormConfigurator.reset();
            }

            if ($interestForm.length > 0) {
                interestForm.reset();
            }
            interestForm.updateType(formExternalService);
            if (brandVal !== undefined && brandVal.length > 0) {
                interestForm.updateBrand(brandVal, brandText);
            }
            interestForm.updateExternalLink(externlLink);
        }
    });

    function initMainMenu() {
        var $wrapper = $('.main-menu', '.header-region');

        var $firstLevel = $('.nav-1 > li > a, .nav-1 > li > span', $wrapper);
        var $secondLevel = $('.nav-2 > li > a , .nav-2 > li > span', $wrapper);

        initMainMenuEffects($firstLevel);
        initMainMenuEffects($secondLevel);

        $('.nav-1', $wrapper).mouseleave(function () {
            $firstLevel.parent().removeClass('hovered');
        });

        $('.nav-2', $wrapper).mouseleave(function () {
            $secondLevel.parent().removeClass('hovered');
        });

    }

    function initMainMenuEffects($submenus) {

        if ($submenus.length == 0)
            return;

        var config = {
            sensitivity: 50,
            interval: 60,
            over: mouseenter,
            timeout: 10,
            out: mouseleave
        };

        function mouseenter() {
            var $el = $(this), formType;

            formType = $el.attr('data-type');
            $el.siblings(".hovered").removeClass('hovered hidden');
            $el.addClass('hovered').siblings('.hovered').removeClass('hovered');
            $('.hovered', '.secondary-menu').removeClass('hovered');

            testDriveForm.show(false);
            serviceForm.show(false);

            if (typeof formType !== "undefined" && formType === "testDrive") {
                testDriveForm.reset();
                testDriveForm.handleErrors();
                testDriveForm.updateType(formType);
                testDriveForm.show(true);
            }

        }

        function mouseleave() {
            return;
        }

        $submenus.parent().hoverIntent(config);
    }

    function initMobileMenus() {
        var $mainMenuwrapper = $('.main-menu', '.header-region');
        //var $secMenuwrapper = $('.secondary-menu', '.header-region');

        var $mainMenuButton = $('.hasChildren > a, .hasChildren > span', $mainMenuwrapper);
        //var $secMenuButton = $('.hasChildren > a, .hasChildren > span', $secMenuwrapper);

        menuButtonHandler($mainMenuButton);

        $('.mobile-inactive', $mainMenuwrapper).on('click', function (e) {
            if ($(window).width() < 960) {
                e.preventDefault();
            }
        });

        $(document).click(function (event) {
            if ((!$(event.target).closest('.main-menu').length &&
               !$(event.target).is('.main-menu')) &&
               (!$(event.target).closest('.secondary-menu').length &&
               !$(event.target).is('.secondary-menu'))) {

                $('.hovered', '.main-menu').removeClass('hovered hidden');
               // $('.hovered', '.secondary-menu').removeClass('hovered hidden');
            }
        });
    }

    openCustomForm();

    function menuButtonHandler($menuButton) {

        $menuButton.on('click', function (e) {
            e.stopPropagation();
            if (!$(this).hasClass('has-url')) {
                e.preventDefault();
            }

            var $this = $(this),
                $parent = $this.parent();

            if ($parent.hasClass('hovered')) {
                $parent.removeClass('hovered hidden').find('.hovered').removeClass('hovered hidden');
                testDriveForm.show(false);
                serviceForm.show(false);
            } else {
                $parent.addClass('hovered').siblings().removeClass('hovered hidden');
                var formType = $parent.attr('data-type');

                if (formType == 'testDrive') {
                    testDriveForm.show(false);
                }else if (formType == 'bookService') {
                    serviceForm.show(false);
                }

                if ($(window).width() < 480) {
                    $('html, body').animate({ scrollTop: $parent.offset().top }, 100, 'swing');
                }
            }


        });

    }
});

